import { CheckOutlined, UndoOutlined } from '@ant-design/icons';
import styled, { css } from 'styled-components';

import { Flex, type FlexProps, VFlex } from '@/components/base';
import Button from '@/components/Button/Button';
import Typo from '@/components/Typography/Typo';
import { radius } from '@/styles/sizes';

type Props = {
  block: FeedbackBlockTWithFeedbackAlias;
  ignored?: boolean;
  onClick: (block: FeedbackBlockTWithFeedbackAlias) => void;
  onIrrelevantClick: (block: FeedbackBlockTWithFeedbackAlias) => void;
  onRestoreClick: (block: FeedbackBlockTWithFeedbackAlias) => void;
};

const FeedbackBlockPreviewItem = (props: Props) => {
  return (
    <Style ignored={props.ignored} onClick={() => props.onClick(props.block)}>
      <Typo type="body2" weight="r">
        {props.block.snippet}
      </Typo>
      {props.ignored ? (
        <Flex j="space-between">
          <Button
            disabled
            variant="ghost"
            leftIcon={<CheckOutlined />}
            sizeType="s"
          >
            Irrelevant
          </Button>
          <Button
            variant="ghost"
            leftIcon={<UndoOutlined />}
            sizeType="s"
            onClick={() => props.onRestoreClick(props.block)}
          >
            Restore
          </Button>
        </Flex>
      ) : (
        <Flex j="flex-end">
          <Button
            variant="secondary"
            sizeType="s"
            onClick={() => props.onIrrelevantClick(props.block)}
          >
            Irrelevant
          </Button>
        </Flex>
      )}
    </Style>
  );
};

type StyleProps = FlexProps & {
  ignored?: boolean;
};

const Style = styled(VFlex)<StyleProps>`
  transition: all 0.2s;
  gap: 16px;
  border: 1px solid ${(props) => props.theme.colors.gray400};
  padding: 12px;
  border-radius: ${radius.token.lg}px;
  cursor: pointer;
  background-color: ${(props) => props.theme.colors.gray100};
  &:hover {
    background-color: ${(props) => props.theme.colors.gray200};
  }
  ${(props) =>
    props.ignored &&
    css`
      border-color: ${(props) => props.theme.colors.gray200};
      color: ${(props) => props.theme.colors.gray500};
    `}
`;

export default FeedbackBlockPreviewItem;
